export const METHOD_OPTIONS = [
  { label: "Discount Code", value: "code" },
  { label: "Automatic Discount", value: "automatic" },
];

export const DISCOUNT_TYPE_OPTIONS = [
  { label: "Amount off order", value: "order_amount" },
  { label: "Amount off products", value: "product_amount" },
  { label: "Buy X Get Y", value: "buy_x_get_y" },
];

export const VALUE_TYPE_OPTIONS = [
  { label: "Percentage", value: "percentage" },
  { label: "Fixed amount", value: "fixed_amount" },
];

export const COUNTRIES_OPTIONS = [
  { label: "All Countries", value: "all" },
  { label: "Specific Countries", value: "specific" },
];

export const CUSTOMER_SEGMENT_OPTIONS = [
  { label: "All Customer segments", value: "all" },
  { label: "Specific Customer Segments", value: "specific" },
];

export const CUSTOMER_OPTIONS = [
  { label: "All Customers", value: "all" },
  { label: "Specific customers", value: "specific" },
];

export const CHANNEL_OPTIONS = [
  { label: "All Channels", value: "all" },
  { label: "Specific Channels", value: "specific" },
];

export const PRODUCT_SCOPE_OPTIONS = [
  { label: "Specific products", value: "specific_products" },
  { label: "Specific categories", value: "specific_categories" },
];

export const MIN_PURCHASE_TYPE_OPTIONS = [
  { label: "No minimum requirements", value: "none" },
  { label: "Minimum purchase amount", value: "amount" },
  { label: "Minimum quantity of items", value: "quantity" },
];

export const BXGY_BUY_TYPE_OPTIONS = [
  { label: "Minimum quantity of items", value: "min_quantity" },
  { label: "Minimum purchase amount", value: "min_amount" },
];

export const BXGY_VALUE_TYPE_OPTIONS = [
  { label: "Percentage", value: "percentage" },
  { label: "Amount off each", value: "fixed_amount" },
  { label: "Free", value: "free" },
];
